// src/components/HUD/HUDWrapper.js
// UPDATED: 2026-08-11 — accepts onHUDLogin callback prop and calls it when
// a hud_analyst session is detected so App.js isHUDOnly updates immediately
// after login without requiring a page refresh.
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import HUDLogin from './HUDLogin';
import HUDAnalyticsDashboard from './HUDAnalyticsDashboard';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function HUDWrapper({ onHUDLogin }) {
  const [authState,   setAuthState]   = useState('checking');
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => { checkSession(); }, []);

  const checkSession = async () => {
    try {
      const res = await axios.get(`${API_URL}/hud/check-session`, { withCredentials: true });
      if (res.data.isAuthenticated) {
        setCurrentUser(res.data.user);
        setAuthState('authenticated');
        if (res.data.user?.role === 'hud_analyst' && onHUDLogin) {
          onHUDLogin();
        }
        return;
      }
    } catch (_) {}

    try {
      const res = await axios.get(`${API_URL}/check/session`, { withCredentials: true });
      if (res.data.isAuthenticated) {
        setCurrentUser({ ...res.data.user, role: 'admin' });
        setAuthState('authenticated');
        return;
      }
    } catch (_) {}

    setAuthState('unauthenticated');
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${API_URL}/hud/logout`, {}, { withCredentials: true });
    } catch (_) {}
    setCurrentUser(null);
    setAuthState('unauthenticated');
  };

  if (authState === 'checking') {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', fontFamily: 'Arial, sans-serif',
        color: '#888780', fontSize: '13px',
      }}>
        Loading...
      </div>
    );
  }

  if (authState === 'unauthenticated') {
    return (
      <HUDLogin onLoginSuccess={(user) => {
        setCurrentUser(user);
        setAuthState('authenticated');
        if (user?.role === 'hud_analyst' && onHUDLogin) {
          onHUDLogin();
        }
      }} />
    );
  }

  return (
    <HUDAnalyticsDashboard
      currentUser={currentUser}
      onLogout={handleLogout}
      isAdmin={currentUser?.role === 'admin'}
    />
  );
}